import React, { FunctionComponent } from 'react';

interface IValidationErrorProps {
  errorMessage?: string
}

const ValidationErrorBlock: FunctionComponent<IValidationErrorProps> = ({errorMessage}: IValidationErrorProps) => (
  <div className="validation-error">
    <p className="error-message">
      {errorMessage}
    </p>
  </div>
);

export default ValidationErrorBlock;
